import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'y42-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  @Input() src: string | null = '';
  @Input() name = '';
  @Input() borderColor?: string;
  @Input() size: string | number = '';
  @Input() cornerRadius: string | number = '';
  @Input() round = true;
  @Input() value?: string | null;
  @Input() bgColor: string | undefined;
}
